// GENERATED FILE — do not hand-edit. Regenerate with:
//   npm run generate:agency-exclusions:prod
// Company IDs where the Companies table has isRecruitmentCompany or isConsultingCompany truthy
// (stored inconsistently as "TRUE"/"FALSE" strings or a DynamoDB bool) — used only to hide
// staffing/consulting agencies from the FilterModal's default
// (unsearched) company list (see FilterBuildingBlocks.tsx). A company still shows up if the user
// searches for it by name, and this list has no effect on job search results themselves. Re-run
// the generator periodically to pick up newly-flagged companies; a stale list just means a newly
// flagged agency keeps showing in the default list until the next regeneration, not a functional
// break.
// Generated 2026-09-09T18:57:43.474Z from 1213 companies.
export const AGENCY_COMPANY_IDS: string[] = [
  "A & A Consulting Oy",
  "A-Kiinteistökonsultti Oy",
  "A-Test & Consulting Oy",
  "A. Björkman Consulting Oy",
  "A.Ojapalo Consulting Oy",
  "A.S.O. Marketing & Consulting Oy",
  "A&H Konsultointi Oy",
  "Aava Consulting Oy",
  "Aavekonsultit Oy",
  "Ab KS Geokonsult Oy",
  "Ab L & H Consulting Oy",
  "Ac Verus Consulting Oy",
  "AC-Anestesia Consulting Oy",
  "Academic Work",
  "Academic Work Academy Finland Oy",
  "ACC Consulting Oy",
  "Access Capital Advisors Finland Oy",
  "Acco Consulting Oy",
  "ACE Consulting Oy",
  "ADE Consulting Oy",
  "Adecco Finland Oy",
  "Adiente",
  "Afore Consulting Oy",
  "Agenteq Consulting Oy",
  "agile42 Consulting Oy",
  "AH Executive Search Oy Ab",
  "Ahkera Henkilöstöpalvelut Oy",
  "Ahlamaa Consulting Oy",
  "Ahlstedt Ström & Keinänen Consulting Oy",
  "Ahlström Consulting Oy",
  "AHN Consulting Oy",
  "AiCan Happy People Oy",
  "Air-Konsult Oy",
  "AJL Consulting Oy",
  "AJM-Konsultit Oy",
  "AK Allokaatio Konsultointi Oy",
  "Aki Leppänen Consulting Oy",
  "Akilles Oy Konsulttitoimisto",
  "AKM Consulting Oy",
  "AKTANTTI Consulting Group Oy",
  "AL MARE CONSULTING AB",
  "Albita Konsultointi Oy",
  "Alexa Henkilöstöpalvelut Oy",
  "Ali Consulting Oy",
  "Allied Travel Consultants Oy Ltd",
  "Alma Consulting Oy",
  "ALMA Consulting Oy",
  "Ama-Konsultointi Oy",
  "Ametro Henkilöstöpalvelut Oy",
  "Amiko Helsinki Oy",
  "Amiko Kouvola Oy",
  "Amiko Oulu Oy",
  "Amiko Oy",
  "Amiko Seinäjoki Oy",
  "Amiko Tampere Oy",
  "Amiko Vantaa Oy",
  "AMS Henkilöstöpalvelut Oy",
  "ANKI Consulting Oy",
  "Annie Advisor Oy",
  "Anttilan Konsultointi Oy",
  "AO-KONSULTOINTI OY",
  "AP-Pine Medical Consulting OY",
  "Apollo Henkilöstövuokraus Oy Oulu",
  "Apotrade Consulting Oy",
  "Apropos Consulting Oy",
  "Aputeam Oy",
  "Apuvoima",
  "Apuvoima Pirkanmaa",
  "Apuvoima Simolin Oy",
  "Aquarius Clinical Consulting Oy",
  "Arcusys Consulting Oy",
  "Arena Henkilöstöpalvelut Oy",
  "Arffman Consulting Oy",
  "Ari Rosenvall Healthcare and Consulting Oy",
  "Arkkitehdit Ingervo Consulting Oy",
  "Arkkitehtitoimisto A-Konsultit Oy",
  "Armstrong Henkilöstöpalvelut Rovaniemi Oy",
  "Aro-Konsultit Oy",
  "Arocom Konsultointi Oy",
  "Arposuo Consulting Oy",
  "Arsenaali Oy",
  "Artturi Tarjanne Consulting Oy",
  "Arvo Advisors Oy",
  "Arvonen Consulting Oy",
  "Arwo Rekry Oy",
  "Arwo Rekry Varsinais-Suomi Oy",
  "Arxe Advisory Services Oy",
  "ASIA RENKO CONSULTING OY",
  "Asianajotoimisto Ulrika Larpes Consulting Oy",
  "ASM-Consulting Oy",
  "Aspectum Consulting Oy",
  "Aspeko Consulting Oy",
  "Ässä-Konsultit Oy",
  "Asuntokonsultit Oy",
  "ATA-Henkilöstöpalvelut Oy",
  "aTalent",
  "ATC Consulting OY",
  "Atlantis Consulting Oy",
  "Audalia Consulting Oy",
  "Audit-Log Consulting Oy",
  "Auranmaan henkilöstöpalvelu Oy",
  "Aurexel Consulting Oy",
  "Avaus Consulting Oy",
  "Avia Konsultointi Oy",
  "Avilanco Consulting Oy LTD",
  "Avolax Consulting Oy",
  "AX-Konsultit Oy",
  "Ba advisors oy",
  "Baconhawk Consulting Helsinki Oy",
  "Balata Henkilöstöpalvelut Oy",
  "Baltic Nuclear Consulting Group BNCG Oy",
  "Barona Customer Care Oy",
  "Barona Customer Service Oy",
  "Barona Finance Oy",
  "Barona Flexible Industries Oy",
  "Barona Global Human Resources Oy",
  "Barona Henkilöstöpalvelut Oy",
  "Barona Horeca Oy",
  "Barona HR Oy",
  "Barona ICT Services Oy",
  "Barona Infra Oy",
  "Barona IT Oy",
  "Barona IT Talent Oy",
  "Barona Julkiset Palvelut Oy",
  "Barona Kauppa Oy",
  "Barona Lapland Oy",
  "Barona Logistiikka Oy",
  "Barona Logistiikkaratkaisut Oy",
  "Barona Luova Oy",
  "Barona Oy",
  "Barona Production Oy",
  "Barona Rakennus Oy",
  "Barona Sales East Oy",
  "Barona Sales North Oy",
  "Barona Sales Oy",
  "Barona Sales Retail Oy",
  "Barona Sales South Oy",
  "Barona Sales South West Oy",
  "Barona Sales Trading Oy",
  "Barona Sales West Oy",
  "Barona SCC East Oy",
  "Barona SCC Fashion Oy",
  "Barona SCC North Oy",
  "Barona SCC North West Oy",
  "Barona SCC West Oy",
  "Barona Solutions Oy",
  "Barona Sote Oy",
  "Barona Tekniikka & Asennus Oy",
  "Barona Teollisuus Oy",
  "Barona Varastopalvelut Oy",
  "BAS Boiler Advisor Service Oy",
  "BassoHR Oy",
  "BCC-Consulting Oy",
  "BCE Ltd Building, Consulting, Engineering Ab",
  "BCM Consulting Oy",
  "BDO Consulting Oy",
  "Beki Consulting Oy",
  "Benefit Advisors Oy",
  "Besku Logistics Oy",
  "Best Bond Henkilöstöpalvelut Oy",
  "Best Workers Suomi Oy",
  "Bevcon Beverage Technology & Consulting Oy",
  "Biisoni Business & Technology Oy",
  "Biisoni Group Oy",
  "Biisoni Oy",
  "Biisoni Pohjanmaa Oy",
  "Biisoni Tampere Oy",
  "Bilot Consulting Oy",
  "Bitrac Ltd Oy-Bilateral Trading and Consulting and Engineering Limited",
  "Bizfin Consulting Oy",
  "BM Raudoitekonsultit Oy",
  "BN Advisors Finland Oy",
  "Bocap SME Advisors Oy",
  "Boiler Consulting K E Salmi Oy",
  "Bolt.Works Oy",
  "Bondata",
  "Bondata Lapland Oy",
  "Bono Consulting Oy",
  "Bonware Consulting Oy",
  "Booster Consulting Oy",
  "Boston Consulting Group",
  "BPS Consulting Finland Oy",
  "Bravura Suomi Oy",
  "Broad Scope Management Consulting Oy",
  "Bull's Consulting Oy",
  "Business Consulting Rekunen Oy",
  "Businesslike Oy Henkilöstöpalvelu",
  "BuyTheWay Consulting Oy",
  "BZW Konsultointi ja Sijoitus Oy",
  "Cadence Advisor Oy",
  "Cadvisors Oy",
  "Calcutec Consulting Oy",
  "Candel Consulting Oy",
  "Candeo Consulting Oy",
  "Carioca Consulting Oy",
  "Carpe Diem Consulting Oy",
  "Carrot Itä-Suomi Oy",
  "Carrot Keski-Suomi Oy",
  "Carrot Länsi-Suomi Oy",
  "Carrot Palvelut Oy",
  "Carrot Pirkanmaa Oy",
  "Carrot Pohjanmaa Oy",
  "Carrot Pohjois-Suomi Oy",
  "Carrot Rakennus Oy",
  "Carrot Tampere Oy",
  "Carrot Uusimaa Oy",
  "Carrot Varsinais-Suomi Oy",
  "CASA CONSULTING OY AB",
  "Cash-In Consulting Oy Ab",
  "Catalina Consulting Oy",
  "Cemi konsultointi Oy",
  "Chemitec Consulting Oy",
  "Choice HR Oy",
  "Circles Consulting Oy",
  "City-Scenario Consulting Oy",
  "Claritas Security Consulting Oy",
  "Clevry Oy",
  "Clevry Solutions Oy",
  "Click Henkilöstöpalvelut Oy",
  "CM & HR Consulting Oy",
  "CM Consulting Oy",
  "Coast Consulting Ab Oy",
  "Compass Human Resources Group",
  "Completo Consulting Oy",
  "Comune Management Consulting Oy",
  "ConFi Consulting Oy",
  "Consulting FFC Oy",
  "Consulting M.Karppinen Oy",
  "Consulting Verticale Coaching Ltd Oy",
  "Contio Henkilöstöpalvelut Oy",
  "Copernicus Consulting Oy",
  "Corporate Advisor Group Oy",
  "Cost Consulting Finland Oy",
  "Count Consulting Oy",
  "Cox Consulting Oy",
  "Craftman Oy",
  "Cubior Consulting Oy",
  "CVplus Consulting Ab Oy",
  "CW Sailing Consultant Oy",
  "Dalenius Consulting Oy",
  "Dane-Consulting Oy",
  "DC Henkilöstövuokraus Oy",
  "DCC Data Communications Consultants Oy",
  "Deal Henkilöstöratkaisut oy",
  "Designlab Consulting Oy",
  "Despe Consulting Oy",
  "Doberman Consulting Oy",
  "DOBRA Consulting Oy",
  "Dobra Finland Oy Ab",
  "Done Henkilöstöpalvelut Oy",
  "DRA Consulting Oy",
  "DSR International Consulting Group Oy",
  "DT-Consulting Oy",
  "Duunaamo Henkilöstöpalvelut Oy",
  "Duunia Henkilöstöpalvelut Oy",
  "Duuniboxi Oy",
  "Dynamo Henkilöstöratkaisut Oy",
  "East Consulting Oy",
  "East-West Psychoconsulting-EWP Oy",
  "EBC Oy Europäisches Bauconsulting",
  "ECAM Consulting Oy",
  "Econia Oy",
  "Edumate Consulting Oy",
  "Edustus ja Konsultointi T.A.E Oy",
  "Eerika Consulting Oy",
  "Eeva Niskavaara Consulting Oy",
  "Eezy Flow Oy",
  "Eezy Henkilöstöpalvelut Oy",
  "Eezy Kauppa Länsi Oy",
  "Eezy Kauppa Suomi Oy",
  "Eezy Osk",
  "Eezy Oyj",
  "Eezy Palvelut Pirkanmaa Oy",
  "Eezy Personnel Oy",
  "Eezy Pohjanmaa Oy",
  "Eezy Sonire Oy",
  "Eezy Teollinen Pohjoinen Oy",
  "Eezy United Oy",
  "Eezy VMP Oy",
  "Efecto Consulting Oy",
  "EH Konsultointi Oy",
  "Ehta Henkilöstöpalvelut Oy",
  "El-Man Konsult Ab",
  "Elomatic Consulting & Engineering Oy",
  "Elomatic Process Consulting Oy",
  "EMC Consulting Oy",
  "Emerging Markets Advisors Oy",
  "Emico Consulting Oy",
  "EMK Consulting Oy",
  "EN Executive Search Oy Ab",
  "EN-Rakennuskonsultti Oy",
  "Encina Consulting Oy",
  "Encore Sales & Consulting Oy",
  "Enegia Consulting Oy",
  "Energiakonsultit insto Oy",
  "Energiateknillinen Konsultointi ETC Oy",
  "Engblom & Co Oy konsulttitoimisto",
  "EP-Consulting Oy",
  "ER-HA Oy Henkilöstövuokraus",
  "Esa Rousu Consulting Oy",
  "Escover Executive Search Oy",
  "Espoon tili- ja verokonsultointi Oy",
  "EST Henkilöstöpalvelut Oy",
  "Etelä-Savon Laskenta ja Konsultointi Ky",
  "Etelä-Suomen Metsäkonekonsultit E.S.M. Oy",
  "Euro Professional Consulting Oy",
  "European Sports Betting Consultants Oyj",
  "Evolvit Consulting Oy",
  "EW Staffing Oy",
  "EXE Headhunting",
  "Eximia Software Consulting Oy",
  "EXP Consulting Oy",
  "Exponent Consulting Oy",
  "ExR-Henkilöstöpalvelut Oy",
  "Fair Warning Henkilöstöpalvelut Oy",
  "Faktia Oy",
  "FAL Consulting Oy",
  "FC Consulting Oy",
  "FCG Finnish Consulting Group Oy",
  "FCG Konsultointi Oy",
  "FENIX CONSULTING Oy",
  "Fennopro-Consulting Oy",
  "FIAC Invest Oy - Finnish Innovative Architecture and Consulting",
  "FICOSAP Consulting Oy",
  "Finarconsulting Oy FINAR",
  "Finesta Finland Oy",
  "FinME Consulting Oy",
  "Finnish Darts Consulting Oy",
  "Finnish Pro Consulting Oy",
  "Fintegra Consulting Group Oy",
  "Fisheries Consulting & Expertice Ltd Ab",
  "Flagsales Consulting Oy",
  "Flair Masters Oy",
  "Flashtec Consultants Oy",
  "Flinkkilä & Rajaniemi Consulting FRC Oy",
  "Florence Henkilöstöpalvelut",
  "Flow Consulting Oy",
  "FMA-Foundation Management Advisors Oy",
  "FME Consulting Oy",
  "FocusIt Consulting Oy",
  "Folka Henkilöstöpalvelut",
  "Forcit Consulting Oy",
  "Forssan Henkilöstöpalvelut Oy",
  "Foxley Consulting Oy",
  "Foxx & Co Consulting Partners Oy",
  "FQ Consulting Oy",
  "Furu Consulting Oy",
  "Fysanna Consulting Oy",
  "Fysioterapia-konsultit FTK Oy",
  "g2 Recruitment",
  "Gaia Consulting Oy",
  "Gamla Consulting Oy",
  "Gator Consulting Oy",
  "GEK Consulting Oy",
  "GLUCAN Consulting Oy",
  "GM-Consulting Oy",
  "Go On Finland Oy",
  "Go On Services I Oy",
  "Go On Services III Oy",
  "Go On Services IV Oy",
  "Go On Services Oy",
  "Go On Services V Oy",
  "Go On Solutions Oy",
  "Good Fellas Oy",
  "Good Staff Henkilöstöpalvelut",
  "GOS Consulting Oy",
  "GoWell Consulting Oy",
  "Grape Consulting Oy",
  "Grundell Henkilöstöpalvelut Oy",
  "GT Consulting Oy",
  "H & H Consulting Oy",
  "H&K Consulting House Oy",
  "Haastava Consulting Oy",
  "Hagström Consulting Oy",
  "Hakoniemi Consulting Oy",
  "Hämeen Henkilöstöpalvelut Oy",
  "Hämeenlinnan Tili- ja Konsultointitoimisto Oy Tapani Oila",
  "Hans Consulting Oy",
  "Happy Henkilöstöpalvelut Oy",
  "Hautanen Consulting Oy",
  "HeadCount",
  "Headhunter Finland Oy",
  "Headhunter House Oy",
  "Heikki Karvonen Consulting Oy",
  "Helmihunter Oy",
  "Helsingin Keskuskonsultit Oy",
  "Helsinki Capital Partners Advisory Oy",
  "Helsinki Medical Consulting Oy",
  "Henkilöstö KP Oy",
  "Henkilöstöliiga",
  "Henkilöstöliiga Pirkanmaa Oy",
  "Henkilöstöliiga Turku Oy",
  "Henkilöstöliiga Uusimaa Oy",
  "Henkilöstöpalvelu Argent 15 Oy",
  "Henkilöstöpalvelu Argent 4 Oy",
  "Henkilöstöpalvelu Argent 5 Oy",
  "Henkilöstöpalvelu Argent Oy",
  "Henkilöstöpalvelu Efectivo Oy",
  "Henkilöstöpalvelu Grouppro Oy",
  "Henkilöstöpalvelu Hallinen Oy",
  "Henkilöstöpalvelu Heimo",
  "Henkilöstöpalvelu Hirmu Oy",
  "Henkilöstöpalvelu Kreat Oy",
  "Henkilöstöpalvelu Linnanväki Oy",
  "Henkilöstöpalvelu Mauri Oy",
  "Henkilöstöpalvelu Narikka.Com Oy",
  "Henkilöstöpalvelu Outrek Oy",
  "Henkilöstöpalvelu Pirttikoski Oy",
  "Henkilöstöpalvelu Reilut Oy",
  "Henkilöstöpalvelu Silkkitie Oy",
  "Henkilöstöpalvelu Silver Service Oy",
  "Henkilöstöpalvelu Syrjälä Oy",
  "Henkilöstöpalvelu VIP Oy",
  "Henkilöstöpalvelut Duuri-tiimi Oy",
  "Henkilöstöpalvelut Tuloksia Oy",
  "Henkilöstöpalveluyhtiö Työmiehet Oy",
  "Henkilöstöratkaisu Extraajat Oy",
  "Henkilöstöratkaisut Rami Räty Oy",
  "Henkilöstövuokraus Kameleontti Oy",
  "Henkilöstövuokraus RENT-X Oy",
  "Henkilöstövuokraus Työkarhut osk",
  "Henkilöstövuokrausyhtiö Kipinä Oy",
  "HEPAConsulting Lukkari Oy",
  "Hevac-konsultit Oy",
  "Hevosmaa Consulting Oy",
  "Hietala Consulting Oy",
  "Hilkos Consulting Oy",
  "Hinkutiimi Oy",
  "Hirvikoski Consulting Oy",
  "Hissikonsultit HS Oy",
  "HJP Consulting - Trading Oy",
  "HLY Consulting Oy",
  "Hoikka Consulting Oy",
  "Hoiwa Oy",
  "Hollolan Konsulttikeskus Oy",
  "Hongisto Consulting Oy",
  "Horjamo Consulting Oy",
  "Horn Afrik työvoimapalvelu Oy",
  "Houston Inc. Consulting Oy",
  "HR Fuel Oy",
  "HR Sata Henkilöstötalo / Workway Oy",
  "HR Solutions Finland Oy",
  "HR Tukku Oy",
  "HR Yhtiöt Oy",
  "HRS Advisors Oy",
  "Hss Consulting Oy",
  "HT Rekrytointi Oy",
  "HTA Consulting Oy",
  "HU-Consulting Oy",
  "Hulkkonen Consulting Oy",
  "Hunaja Works Oy",
  "Hungarokonsult Oy",
  "I-bdc Consulting Oy",
  "Idego Consulting Oy",
  "Idestra Consulting Oy",
  "IF Spedition Consulting Oy",
  "IIS-Consulting Oy",
  "Ikaalisten Kiinteistökonsultit Oy",
  "Imatran Tilikonsultit Oy",
  "Impact Consulting Oy Ltd",
  "Independent Consulting Oy",
  "Ingmar Westerlund Consulting Oy",
  "Inmeco Oy Rakennuskonsultit",
  "Inmed-Consulting Oy",
  "Innovate Consulting Espoo Oy",
  "Insight Consulting Hyrck & Väisänen Oy",
  "Insinööri- ja konsulttitoimisto Toltti Oy",
  "Insinööritoimisto Muilu Consulting OY",
  "Insinööritoimisto Tuutti Consulting Oy",
  "Inspiro Consulting Oy",
  "Insteam Consulting Oy",
  "J. Waxlax Consulting Ab",
  "J.I.L. Consulting Oy",
  "J.Nurmela Consulting Oy",
  "JADEVA Consulting Oy",
  "JAM Advisors Oy",
  "Jari Asunmaa Konsultointi Oy",
  "Järvi-Suomen Kiinteistökonsultit Oy",
  "Jasa JTJ Consulting Oy",
  "Jätekonsultointi Sawa Oy",
  "Jatomaki Consulting Oy",
  "Javanainen Consulting Oy",
  "Jeesi Henkilöstöpalvelut Oy",
  "Jelppi Henkilöstöpalvelut Oy",
  "JEP Henkilöstöratkaisut Oy",
  "JETS consulting Oy",
  "JFP Executive Search Oy",
  "JHG Consulting Oy",
  "JIT Consulting Oy",
  "JKC Oy Consulting",
  "JLH Henkilöstöpalvelut Oy",
  "JMI Consulting Oy",
  "JO Consulting Ab",
  "Joanto Consulting Oy",
  "Job Henkilöstöpalvelut",
  "Jobby Oy",
  "Joblink Logistiikka Oy",
  "Joblink Myymäläpalvelut Oy",
  "Joblink Oy",
  "Joblink Rakennus Oy",
  "JobPari Oy",
  "Jobros Oy",
  "Joen Tilikonsultit Oy",
  "Johansson Consulting Oy",
  "Johto Advisors Oy",
  "Jorma Ratia Consulting Oy",
  "Joukan - konsultointi Oy",
  "JP Cornerstone Executive Search Oy Ab",
  "JPM Consulting Oy",
  "JS Crane Consulting Oy",
  "JS Konsultointi Oy",
  "JSM Consulting Oy",
  "JT Consulting & Trading Oy",
  "Juha Kuokkanen Consulting Oy",
  "Juha Lipponen Consulting Oy",
  "JUHO Consulting Oy",
  "Juho Lipsanen Consulting Oy",
  "Juho Uusihakala Consulting Oy",
  "Julkisivukonsultointi JK Oy",
  "JULMA consulting Oy",
  "Just IT Consulting Finland Oy",
  "Juuriharja Consulting Group Oy",
  "Juvander Consulting Oy",
  "JW-ENVIRONMENT CONSULTING AB",
  "JWD Palvelut",
  "Jyväskylän Henkilöstöpalvelut Oy",
  "Jyväskylän Yrityskonsultit Isännöinti Oy",
  "Jyväskylän Yrityskonsultit Oy",
  "K.I. Konsult Oy",
  "KA-Consulting Oy",
  "Kai Joronen Photo & Consulting Oy",
  "Kaisaniemen Konsultit Oy",
  "Kalannin Consulting Oy",
  "Kallio & Stammeier Consulting Oy",
  "Kalliotekniikka Consulting Engineers Oy",
  "Kamensky Consulting Oy",
  "Kami Consulting Oy",
  "Kane Consulting Oy",
  "Kansallis Konsultti Oy",
  "Kari Engelbarth Consulting Oy",
  "Karjalainen Software Consulting Oy",
  "Karkkimala Consulting Oy",
  "Kaspian Law & Consulting Oy",
  "Katarauna Consulting Oy",
  "Katme Consulting Oy",
  "Kauklahden Konsultit Oy",
  "Kaupan koulutus ja konsultointi Markku Mertanen Oy",
  "Kaveriontti Oy",
  "KCC Kouvolan Konsulttikeskus Oy",
  "Kehityspiikki Consulting Oy",
  "Kenttä Consulting Oy",
  "Kesälahti Consulting Oy",
  "Keski-Luopa Konsultointi Oy",
  "Kestävä Sales&Consulting",
  "Kestilä Consulting Oy",
  "Ketjufi Yrittäjärekrytointipalvelut Oy",
  "Kevi Consulting Oy",
  "KeyStaff Oy",
  "Kiinteistö- ja konsulttipalvelut Mire Oy",
  "Kiinteistökonsultit Törmälä Oy",
  "Kiinteistökonsultointi Oy KRA",
  "Kiinteistökonsultti PP-Con Oy",
  "Kilta Henkilöstöpalvelu Oy",
  "Kinnula Consulting Oy",
  "Kiodynos Consulting Oy",
  "Kirurgikonsultointi Kallio Oy",
  "Kiss Konsultointi Oy",
  "Kivikonsultit Oy",
  "Kivini Consulting Oy",
  "KJS-konsultointi Oy",
  "KK-Palokonsultti Oy",
  "KKS Consulting Oy",
  "KM Sport Consultant Oy",
  "KML Consulting Oy",
  "Konsulting Skoko Oy",
  "Konsultointi Anne Eino Oy",
  "Konsultointi Arttu Oy",
  "Konsultointi ja Koulutus MMD Oy",
  "Konsultointi ja tilintarkastus Ilkka Yli-Räisänen Oy",
  "Konsultointi Juha Vikman Oy",
  "Konsultointi Kalervo Ronkainen Oy",
  "Konsultointi Kareg Oy",
  "Konsultointi Kari Kanerva Oy",
  "Konsultointi Knuuttila Oy",
  "Konsultointi Marja-Liisa Lassila Oy",
  "Konsultointi Martikainen Oy",
  "Konsultointi Nurmi Oy",
  "Konsultointi Paimart Oy",
  "Konsultointi Peltomaa Oy",
  "Konsultointi Puttonen Oy",
  "Konsultointi Respa Oy",
  "Konsultointi Tapio Holopainen Oy",
  "Konsultointi V. Laakso & Co Oy",
  "Konsultointi Vettenranta Oy",
  "Konsulttipalvelu Finer Oy",
  "Konsulttipalvelut Dextra Oy",
  "Konsulttitoimisto Aivoriihi Oy",
  "Konsulttitoimisto Cadcase Oy",
  "Konsulttitoimisto Cadlink Oy",
  "Konsulttitoimisto Connector Oy",
  "Konsulttitoimisto Jaakko Lehto Executive Search Oy",
  "Konsulttitoimisto Juha Puustinen Oy",
  "Konsulttitoimisto Kotoba oy",
  "Konsulttitoimisto Marikko Oy",
  "Konsulttitoimisto Martti Ronkainen Oy",
  "Konsulttitoimisto MAT-RA Oy",
  "Konsulttitoimisto Mieli Mukana Oy",
  "Konsulttitoimisto Pasi Sarinko Oy",
  "Konsulttitoimisto Pekka Somppi Oy",
  "Konsulttitoimisto Proximatum Oy",
  "Konsulttitoimisto Reneco Oy",
  "Konsulttitoimisto Saraste Oy",
  "Konsulttitoimisto Seppo Hoffrén Oy Consultancy",
  "Konsulttitoimisto Työmaa Oy",
  "Kontio Consulting Oy",
  "Kontro & Peuru Consulting Group Oy",
  "Kontturi Consulting Oy",
  "Kontu Oy työnohjaus-, koulutus- ja konsultaatiopalvelut",
  "Kooditutorit Konsultointi Oy",
  "Kooka Consulting Oy",
  "Korenius Consulting Oy",
  "Koskela Consulting Oy",
  "Koski Consulting Oy",
  "KP-konsultointi Oy",
  "KR-Konsultit Oy",
  "KRu Consulting Oy",
  "Kruunu HR",
  "KSKT-Consulting Oy",
  "KT-Henkilöstöpalvelut Oy",
  "KTEL-Consulting Oy Ltd",
  "KTS Konsulttitoimisto Hyvät Neuvot Oy",
  "KTT-Konsultit Oy",
  "Kuljus Consulting Oy",
  "Kultaiset Henkilöstöpalvelut Oy",
  "Kurki Consulting Oy",
  "Kuuluvainen Konsultointi Oy",
  "KW Catering & Consulting Oy",
  "Kymen Siivoustukku ja -konsultointi Oy",
  "Kymenlaakson Henkilöstöpalvelut Oy",
  "Kymppi Consulting Oy",
  "Kymppikerho rekrytointipalvelut Oy",
  "Lääkekoulutus ja konsultaatio Jouni Ahonen Oy",
  "Lahden Monialakonsultit Oy",
  "Lahdenkylän henkilöstövuokraus Oy",
  "Laiterä Consulting Oy",
  "Lakkakorpi Consulting Oy",
  "Lalu Consulting Oy",
  "Lammela Consulting Oy",
  "Lankinen Consulting Oy",
  "Länsi-Uudenmaan Laskenta ja Konsultointi Oy",
  "Lapin LVI-konsultointi Oy",
  "Lapland Staff Oy",
  "Lappeenrannan Henkilöstöpalvelut Oy",
  "Laskenta ja konsultointi Kilpeläinen Oy",
  "Laskentakonsultit Oy",
  "Laura Rekrytointi Oy",
  "Lavonia Henkilöstöpalvelut Oy",
  "Lavonia Oy",
  "LCA Consulting Oy",
  "LEAD Henkilöstöratkaisut Oy",
  "Legioona Oy",
  "Leino Consulting Oy",
  "Lettijeff Consulting AB",
  "LHH Consulting Oy Ab Ltd",
  "LHX Consulting Oy",
  "Lindénkonsult, Herbert Lindén Ab",
  "Link Consulting Oy",
  "Lisäpalvelu",
  "Lisäpalvelu Itä-Uusimaa Oy",
  "Lisäpalvelu Jyväskylä Py",
  "Lisäpalvelu Kanta-Häme Oy",
  "Lisäpalvelu Kotka Oy",
  "Lisäpalvelu Kouvola Oy",
  "Lisäpalvelu Lappeenranta Oy",
  "Lisäpalvelu Oulu Oy",
  "Lisäpalvelu Tampere Oy",
  "Lisäpalvelu Teollisuus LPF Oy",
  "Lisäpalvelu Vantaa Oy",
  "Lisäpalvelu Varsinais-Suomi Oy",
  "LNK-Consulting Oy",
  "LogiConsulting Oy",
  "Lokki Henkilöstöpalvelut Oy",
  "Louhia Consulting Oy",
  "Lumme Consulting & Partners Oy",
  "Lumo Consulting Oy",
  "Luola Consulting Oy",
  "Luova Ihminen koulutus ja konsultointi Oy",
  "LVI-insinööritoimisto Koski-Konsultit Oy",
  "LVI-Konsultointi R. Määttä Oy",
  "M & A Advisors Finland Oy",
  "M Kangas Consulting Oy",
  "M.Repo Consulting Oy",
  "Magenta Advisory Oy",
  "Major HR Consulting Oy",
  "Mäkipää Consulting Oy",
  "Management Consulting Rope Oy",
  "Manpower",
  "Marckwort Kouluttajat - Consultants Oy",
  "MARIEHAMNS ELKONSULT Ab",
  "Mariehamns Ingenjörskonsult Ab",
  "Markku Iljina GeoConsulting Oy",
  "Max Henkilöstöpalvelut Oy",
  "MAX Potential Coaching & Consulting Oy",
  "Maya Consulting Oy",
  "MechChiefConsulting Oy",
  "Medical Interscience Talents M.I.T. Consulting Oy Ltd",
  "Menefta Consulting Oy",
  "Mentek Advisors Oy",
  "Mentor Consulting Oy",
  "Merit Consulting Oy",
  "Mertaoja Consulting Oy",
  "Mervin Consulting Oy",
  "Mestarit Henkilöstöpalvelut Oy",
  "Metacase Consulting Oy",
  "MFD Consulting Oy",
  "Miettinen Consulting Ltd Oy",
  "Miili Consulting Oy",
  "Mika Oukka Consulting Oy",
  "Mikheev Consulting Oy",
  "MindFit Consulting Oy",
  "Mindin Consulting Oy",
  "Minico Consulting Oy",
  "Miracle Consulting Oy",
  "MK Konsultointi Oy",
  "MKA Consulting Oy",
  "MLE Consulting Oy",
  "MM - Rekrytointi Oy",
  "MMe konsultointi oy",
  "Moen Consulting Ab",
  "Mona Advisors Oy",
  "Monday Morning Consulting Oy",
  "Monitoimi Konsultit Oy",
  "MPH Consulting & Invest Oy",
  "MPS Executive Search Oy",
  "MSA Consulting Oy",
  "mSpeed Consulting Oy",
  "MSTConsulting Oy",
  "MT Xport Consultants Oy",
  "MTW-Konsultointi Oy",
  "Muovikonsultointi Kujansuu Oy",
  "MW-Henkilöstöpalvelut Oy Ab",
  "Mycon Consulting Oy",
  "N-Konsultit Oy",
  "N-Pro Resources Oy Ltd",
  "NanoAnalysis Consulting Oy",
  "NC Advisory Oy",
  "NDT Inspection & Consulting Oy",
  "NED Software Consulting Oy Ltd",
  "Neomore Consulting Oy",
  "Netlight Consulting Oy",
  "Netum konsultointi Oy",
  "New Beat Consulting Oy",
  "Nexon Consulting Oy",
  "NGA Human Resources Oy",
  "NHG Consulting Oy",
  "Nice-business Consulting Oy",
  "Nijoteam Consulting Oy",
  "NIK Consulting Oy",
  "Nikkeli Consulting Oy",
  "Nissilä Consulting Oy",
  "Nivari Consulting Oy",
  "Nordic Board Agents and Consultants Limited Oy",
  "Nordic Henkilöstöpalvelut Oy",
  "Nordic International Marketing and Consulting Oy Ltd",
  "Nordic JobCentre Oy",
  "Nordlink Henkilöstövuokraus Oy",
  "Nordrec Henkilöstöpalvelut Oy",
  "Norest Consulting Oy",
  "Noro Consulting Oy NCO",
  "NorthWind Consulting Oy",
  "Nosto Consulting Oy",
  "NOWIA CONSULTING OY",
  "NPA-Consulting Oy",
  "NSD Consulting Oy",
  "Nurmi Consulting Oy",
  "Ohjauskonsultit Oy",
  "Öhman Consulting Oy",
  "OKMS-Consulting Oy",
  "Ole hyvä-Konsultit Oy",
  "Open Consulting Oy",
  "Operaria Oy",
  "OPM Advisory Oy",
  "Opteam autonrakentajat Oy",
  "Opteam Bar Oy",
  "Opteam City Oy",
  "Opteam Espoo Oy",
  "Opteam Etelä-Karjala Oy",
  "Opteam Hyvinkää Oy",
  "Opteam Itä-Suomi Oy",
  "Opteam Järvenpää Oy",
  "Opteam Kauppa Oy",
  "Opteam Logistics Oy",
  "Opteam Lounais-Suomi Oy",
  "Opteam Market Oy",
  "Opteam Media Oy",
  "Opteam Oulu Oy",
  "Opteam Oulun Teollisuus Oy",
  "Opteam Pohjois-Pohjanmaa Oy",
  "Opteam Raisio Oy",
  "Opteam Ravintola Oy",
  "Opteam Teollisuus Oy",
  "Opteam Turku Oy",
  "Opteam Vantaa Oy",
  "Optimax Henkilöstöratkaisut Oy",
  "Optimum Insurance Consultants OY",
  "Orbion Consulting",
  "Orlando Consulting Oy",
  "Orthokonsult Oy",
  "Osola Consulting Oy",
  "Ossi-Konsultointi Oy",
  "Osuma Henkilöstöpalvelut",
  "Oy Agrofor Consulting Ltd",
  "Oy Akat Consulting Ab",
  "Oy Andreas Ehnberg Consulting Ab",
  "Oy Arkadian Firmakonsultit Ltd",
  "Oy Atlas Geoconsulting Ab",
  "Oy Autrol Consulting Ab",
  "Oy BAS-Consulting Ab",
  "Oy Brink Consulting Ab",
  "Oy Consulting Factor Ltd",
  "Oy Dama Consulting Ab",
  "Oy DE-Consulting Ltd",
  "Oy Ehnholm Consulting Ab",
  "Oy Finnish China Consulting Ltd",
  "Oy FinnKonsultant Ltd",
  "Oy Håkan Nordqvist Consulting Ab",
  "Oy IP-Worldwide Consulting Ltd",
  "Oy J-M Consulting Ab",
  "Oy K-O Nyman-Consulting Ab",
  "Oy Kalottkonsult Ab",
  "Oy KRS-Consulting Ltd",
  "Oy Lilako-Liikelahjakonsultit Ltd",
  "Oy Lindström Consulting Ab",
  "Oy Marine Consulting Suksi Ltd",
  "Oy MPT-Consulting Ab",
  "Oy Norm-Esko Consulting Ab",
  "Oy Norma Consulting Ab",
  "Oy Pekka Sjöberg Consulting Ab",
  "Oy R-Wood Consulting Ltd",
  "Oy R.A.Nyberg Consulting Ltd",
  "Oy Revico Consulting Ab",
  "Oy Ringbom Consulting Ab",
  "Oy RM-Consulting Malmberg Ab",
  "Oy RT-SW Consulting Ab",
  "Oy SFA-Consulting-Marketing Group Ltd",
  "Oy SHH Academic Business Consulting Ab",
  "Oy Stenros Consulting Ab",
  "Oy Sundman Consulting Ab",
  "Oy Swot Consulting Finland Ltd",
  "Oy Three Ties Consulting Ltd",
  "Oy Thylins Consulting Ab",
  "Oy Tiara Consulting Ab",
  "Oy Trio Consulting Group Ab",
  "Oy Turun Konsulttitoimisto Åbo Konsultbyrå Ab",
  "P&J Konsultointi Oy",
  "P4 Consulting Oy",
  "Pääkaupunkiseudun Rakennekonsultit Oy",
  "Pääkaupunkiseudun Rakennuskonsultit Oy",
  "Paasivirta Consulting Oy",
  "PAF-Consulting Abp",
  "Paikkaajat Oy",
  "Pajala Konsultointi Oy",
  "Palmén Consulting Oy",
  "Palmroth Consulting Oy",
  "Parkkila Consulting Oy",
  "Parturi-Kampaamo Konsultointi K. Turtiainen Oy",
  "Patenttikonsultointi Kangasmäki Oy",
  "Paula Hunziker Consulting Oy",
  "PB Business Consulting Oy",
  "pdca Consulting Oy",
  "Peope Consulting Oy",
  "People & Leadership Consulting PLC Oy",
  "Persona Consulting Nordic Oy",
  "Persona Henkilöstöratkaisut Oy",
  "Personalhuset Staffing Group Oy",
  "Pertec Consulting Oy",
  "Petri Hynynen Consulting Oy",
  "Petro Consulting Oy",
  "PGS Consulting Oy",
  "PIL Paloilmoitinliike Consulting Oy",
  "Pirhonen Consulting Oy",
  "Pirkanmaan Teollisuuden Henkilöstöpalvelut Oy",
  "Pivotal Consulting Oy",
  "PJU Energy Consulting Oy",
  "PL-Consulting & Training Oy",
  "PM Henkilöstöpalvelut",
  "Polarcom Consulting Oy",
  "PolarPro Henkilöstöratkaisut Oy",
  "Poolia IT",
  "Poolia Suomi Oy",
  "Poolia Works",
  "Poskela Consulting Oy",
  "Pöyry Management Consulting Oy",
  "Prakticonova Oy",
  "Precedo Consulting Oy",
  "Premico Consulting Oy",
  "Premium Advisors Oy",
  "Presto Artist & Consulting Oy",
  "Prior Konsultointi Oy",
  "Prisma Consulting Oy",
  "Pro Growth Consulting Oy",
  "Pro HR Consulting Oy",
  "Pro Materials Consulting Oy",
  "Proffice Finland Oy",
  "Profinntec Oy Consulting Engineers",
  "Profit Consulting Oy",
  "Profit Up Consulting Oy Ab",
  "Profos Consulting Oy",
  "Prometheus Trading & Consulting Oy",
  "Promitheas Consulting Oy",
  "proROSTERI henkilöstöratkaisut Oy",
  "Provenio Consulting Oy",
  "PS Consulting Oy",
  "PS-Advisor Oy",
  "PSA Consulting Oy",
  "PST Consulting Oy",
  "Psykoterapia ja konsultointi Kivimäki Oy",
  "PT-Kaupan Henkilöstöpalvelut Oy",
  "PT-konsultit Mikko Hellsten Oy",
  "PTu Konsultointi Oy",
  "Pulp and Power Consulting Mäntynen & Fonseca Oy",
  "Q2 Consulting Oy",
  "Queo Consulting Ab Ltd",
  "QWC Consultants Oy",
  "R. Mattson Consulting Ab",
  "R&I Consulting Oy",
  "RA Consulting Oy",
  "Raahen Konsultit Oy",
  "Radiant Consulting Oy",
  "Raiconsulting Oy",
  "Rajala Consulting OY",
  "Räjäytyskonsultit Oy",
  "Rakennuskonsultit Oy Peltonen",
  "Rakennuskonsultointi A. Suominen Oy",
  "Rakennuskonsultointi Ismo Kunttu Oy",
  "Rakennuskonsultointi K-Suunnittelu Oy",
  "Rakennuskonsultointi Treuthardt Oy",
  "Rakennuttajakonsultti Tuomo Saari Oy",
  "Rakentaminen ja konsultointi Ahlstrand Oy",
  "Ramboll Management Consulting Oy",
  "Ramboll Projektikonsultointi Oy",
  "Rapp Valvontakonsultit Oy",
  "Rauman Henkilöstöpalvelu Oy",
  "Rausku Henkilöstöpalvelut Ky",
  "Rautkylä Konsultointi Oy",
  "Reko-Konsultit OY",
  "Rekry Group Oy",
  "Rekrycon Oy",
  "Rekryluuri",
  "RekryMesta",
  "Rekrymesta Henkilöstöpalvelut Oy",
  "Rekryovi Oy",
  "Rekryt Foodstuff Oy",
  "Rekrytointipalvelu Sihti Oy",
  "Rekrytointipalvelu Ura-Agentit Oy",
  "Rekrytointitalli Oy",
  "Renesans Consulting Oy",
  "REnium Advisors Oy",
  "RePe Consulting Oy",
  "Resta Henkilöstöpalvelut Oy",
  "Restructuring Advisors Finland Oy",
  "Resurssi Henkilöstöpalvelut Oy",
  "Retail Soft Consulting - RSC Oy",
  "RG Driving Consulting Oy",
  "RHD Consulting Oy",
  "Rianno Consulting Oy",
  "Riihi Consulting Oy",
  "Riihimäen Henkilöstöpalvelut Oy",
  "Riserva Consulting Oy",
  "Rissanen Consulting Oy",
  "Ritzmo Consulting Ab",
  "Riverside Consulting Oy",
  "RL-Consulting Oy",
  "RMB-Consulting Oy",
  "RMC Risk Management Consulting Oy",
  "Road Consulting Oy",
  "Rohjeta Advisors Oy",
  "Rosenberg Audit & Consulting Oy Ab",
  "Rosenblad Consulting Ab Oy",
  "RRJ Consulting Oy",
  "RT Konsultit Oy",
  "RTK-Henkilöstöpalvelu Oy",
  "Ruutu Consulting Oy",
  "RW-konsultointi Oy",
  "RWY-Consulting Oy",
  "S. Saksa Consulting Oy",
  "S.I. Konsult Oy",
  "Saarimäki Consulting Oy",
  "Saba Consulting Oy",
  "Safety Advisor Oy",
  "Sähkökonsultti Ojala Oy",
  "Sahra Agribusiness Consulting Oy",
  "Salin Consulting Oy",
  "Salmivuori Consulting Oy",
  "Salon Tilikonsultti Oy",
  "Salus Qualitas Consulting Oy",
  "Sance-Sandelin consulting and engineering Oy",
  "Sanik Consulting Oy",
  "Sarastia Rekry Oy",
  "Sarrio Consulting Oy",
  "Sastamalan Henkilöstöpalvelut Oy",
  "Satu Kalmi Consulting Oy",
  "SAVVYPATH CONSULTING OY",
  "SCK Consulting Oy",
  "Search & Selection - S & S Consulting Oy Ab",
  "Second Opinion Strategic Advisory Oy",
  "Selektio Consulting Ab",
  "Selja Consulting Oy",
  "Senpai Consulting Oy",
  "SER Consulting Oy",
  "Servicepoint Consulting Oy",
  "Seure Henkilöstöpalvelut Oy",
  "SH-Rakennuskonsultti Oy",
  "Ship Consulting Ltd Oy",
  "ShopAdvisor Finland Oy",
  "SI Consulting Ab Oy",
  "Sigma Consulting Oy",
  "Sijaiset.fi Henkilöstöpalvelut",
  "Siljan Konsult Ab",
  "Sinisaari Consulting Oy",
  "Sinkkonen Consulting Oy",
  "Siro Consulting Oy",
  "Skillio Oy",
  "SOI Consulting & Associates Oy",
  "SOL Henkilöstöpalvelut Oy",
  "Solidia Consulting Oy",
  "Soluta Henkilöstöratkaisut Oy",
  "Someron Laki- ja Verokonsultit Oy",
  "Sparta Consulting Oy",
  "Spinverse Management Consulting Oy",
  "Spjut Consulting Oy Ltd",
  "SQ Consulting Oy",
  "SR Consulting Oy",
  "SSPM Consulting Oy",
  "Staffer Henkilöstöpalvelut",
  "Staffmax Oy",
  "StaffMill Oy",
  "Staffpoint Holding Oy",
  "StaffPoint HR Oy",
  "StaffPoint Oy",
  "Stafko Henkilöstöpalvelut Oy",
  "Staria Consulting Oy",
  "Stranden Consulting Oy",
  "Strax-Konsultointi Oy",
  "Su-Je Konsult Ab",
  "Succedo Invest & Consulting Oy Ab",
  "Suhonen Consulting Oy",
  "Sunshine Consulting Oy",
  "Suomen Henkilöstöpalvelut Oy",
  "Suomen Henkilöstövuokraus Oy",
  "Suomen Hissikonsultti Oy",
  "Suomen Musiikkikonsultit Oy",
  "Suomen Paikkatietokonsultit Oy",
  "Suomen Pelikonsultointi Oy",
  "Suomen Rakennus ja Konsultointi Oy",
  "Suunnittelu- ja konsultointipalvelut Koivula Oy",
  "Suunnittelu- ja konsultointiyritykset SKOL ry",
  "Suuripää Consulting Oy",
  "Sveins Consulting Oy",
  "Synergia Henkilöstöratkaisut Oy",
  "Synergy Management Consultants Finland SMCF Oy",
  "Systevo Oy System Evolution Consultants",
  "T. Koskinen Consulting Oy",
  "T1 Turvakonsultointi Oy",
  "T2O Consulting Oy",
  "T3S Consulting Oy",
  "TA Konsultit Oy",
  "Taipuva Consulting Oy",
  "Taite Organisaatiokonsultointi Oy",
  "Taitokonsultointi Oy",
  "Taivassalon Henkilöstöpalvelu Oy",
  "Takeoff Consulting Group Oy",
  "Talenom Consulting Oy",
  "Talenom Konsultointipalvelut Oy",
  "Talent Center Henkilöstövuokraus Oy",
  "Talling Consultants Ltd Ab",
  "TalousAdvisor Oy",
  "Talouskonsultointi Mertaoja Oy",
  "Talouskonsultointi-Aureus Oy",
  "Tampereen Henkilöstöpalvelut Oy",
  "Tampereen Palvelualojen Henkilöstöpalvelut Oy",
  "Tampereen tekninen konsultointi Oy",
  "Tampereen Tili ja Konsultointi Oy",
  "Target Headhunting Oy",
  "Teampa Henkilöstöpalvelut Oy",
  "TEC TransEnergy Consulting Oy",
  "Tech Consulting Group TCG Oy",
  "Technetium Consulting Oy",
  "Technical Management Consultant in Helsinki Oy",
  "Tempore Henkilöstöpalvelut Oy",
  "Tensicon Consulting Oy",
  "Terävä Consulting Oy",
  "Teromaa Consulting Oy",
  "Terveyden- ja kauneudenhuollon konsultointipalvelu Oy Teekoo",
  "Testipaja Consulting Oy",
  "The Boston Consulting Group Nordic Ab, Filial i Finland",
  "Tiedotus Sinkko Consulting Oy",
  "Tietotili Consulting Oy",
  "Tiger Consulting Finland Oy",
  "Tilakonsultit TM2 Oy",
  "Tili ja Konsultointi KOM Oy Ltd.",
  "Tili- ja Konsultointipalvelu Finndata Oy",
  "Tili- ja Konsulttipalvelu Laskentakanava Oy",
  "Tili- ja Konsulttitoimisto Kiveko Oy",
  "Tili- ja Konsulttitoimisto Lindström Oy",
  "Tili- ja yrityskonsultointi EiVi Ky",
  "Tili- ja yrityskonsultointi PV Oy",
  "Tilintarkastus ja Yrityskonsultointi Markku Leino Oy",
  "Timo Kivisto Consulting Oy",
  "Timo Peltola Consulting Oy",
  "TJ Consulting Oy",
  "TJP Consulting Oy",
  "TMG Consulting Oy",
  "TMH Consulting Oy",
  "TMH Konsultointi Haavisto Oy",
  "TMM Consulting Oy",
  "TMO Consulting Oy",
  "TNK Medical consulting Oy",
  "TNT Rekrytointi Oy",
  "Toda Consulting Oy",
  "Töitä Suomesta työvoimapalvelut Oy",
  "Toivonen Consulting Oy",
  "Tomorrows Consulting Oy",
  "TOP Construction & Consulting Oy",
  "Torni Consulting Oy",
  "TOTAL-Henkilöstöpalvelut Oy",
  "Trellum Consulting Oy",
  "TRH-konsultointi Oy",
  "Triar Consulting Oy",
  "Trim Maritime Consulting Finland Oy",
  "True Consulting Oy",
  "TTA Consulting Oy",
  "Tuija Stenbäck Consulting Oy",
  "Turbiini Consulting Oy",
  "Turun Rahoituskonsultointi Oy",
  "Turun Restahenkilöstövuokraus Oy",
  "TV INFRACONSULTING SERVICE OY",
  "Twinspark Consulting Oy",
  "UMBRELLA STRATEGIC ADVISORY OY",
  "Unicom Consulting Oy",
  "UP Consulting Oy",
  "UPC Konsultointi Oy",
  "UTP - Uudenmaan Työvoimapalvelu Oy",
  "Vakka-Suomen Henkilöstöpalvelu Oy",
  "Valkyria Consulting Oy",
  "Valpas Henkilöstöpalvelut Oy",
  "Valpro Henkilöstöratkaisut",
  "VALPRO Henkilöstöratkaisut Oy",
  "Valpro Rekrytointi",
  "Valtti Henkilöstöratkaisut Oy",
  "Vantaan SAFE-TEAM Consulting Oy",
  "VARA-APU Henkilöstöpalvelut Oy",
  "Värväämö Group Oy",
  "Veijonen Consulting Oy",
  "Veikkola Consulting Group Oy",
  "Vepese Consulting Oy",
  "Verde Henkilöstöpalvelut Oy",
  "Verona Consulting Oy",
  "Vetokonsultit Oy",
  "Via Consulting YVG Oy",
  "Vicus Capital Advisors Oy",
  "Vihermaa Consulting Oy",
  "Viipurinkadun X-ray Konsultointi Oy",
  "Viisikko-Communica Advisors Oy",
  "VISIO Henkilöstöratkaisut",
  "VISIO Henkilöstöratkaisut Kaakko Oy",
  "VISIO Henkilöstöratkaisut Keski-Suomi Oy",
  "VISIO Henkilöstöratkaisut Päijät-Häme Oy",
  "VISIO Henkilöstöratkaisut Pirkanmaa Oy",
  "VISIO Henkilöstöratkaisut Pohjois-Pohjanmaa Oy",
  "VISIO Henkilöstöratkaisut Uusimaa Oy",
  "VISIO Henkilöstöratkaisut Varsinais-Suomi Oy",
  "Visma Consulting Oy",
  "Vistamex Consulting Oy",
  "VJ-Konsultointi Oy",
  "Vojna Tapola Consulting Oy",
  "VPS Henkilöstöpalvelu",
  "VTV Consulting Oy",
  "Vuokratyöpalvelu Parantainen Oy",
  "WAN Consulting oy",
  "Wasa Team Consulting AB",
  "WayStep Consulting Oy",
  "WE Rekry Itä Oy",
  "WE Rekry Oy",
  "WeDo Consulting Oy",
  "Wega Advisors Oy",
  "West´s Konsult & Elitbygg Ab",
  "Wetrock Capital & Consulting Oy",
  "Wilma Consulting Oy",
  "WIM-Advisors Oy",
  "Winpro Henkilöstöpalvelut",
  "Winston Wolf Consulting Oy",
  "WIS Consulting Oy",
  "Wise Consulting Finland Oy",
  "Workbox Henkilöstöpalvelut Oy",
  "Worker Etelä-Suomi Oy",
  "Worker Finland Oy",
  "Worker Henkilöstöratkaisut",
  "Worker Kainuu Oy",
  "Worker Pohjanmaa Oy",
  "WP Henkilöstöpalvelut",
  "Wulff Works Oy",
  "X-Factor Henkilöstöpalvelut OY",
  "Y3 Milestone Coaching & Consulting Oy Ltd",
  "YES Your Excellent Staff Oy",
  "Ylämyllyn Tilikonsultit Oy",
  "Ylinen Real Estate & Consulting YRC Oy",
  "Ympäristökonsultointi Niemeläinen Oy",
  "Yoka Consulting Oy",
  "Yrityskonsultit Forest Oy, Jyväskylä",
  "Yrityskonsultointi Markku Larikka Oy",
  "Zalaris HR Services Finland Oy",
  "Zimmi Consulting Oy"
];
